const {GlobalEvent} = require("./global-event");

const GlobalMouseMove = ({fn}) =>
    GlobalEvent({
        eventName: "mousemove",
        fn,
    });
exports.GlobalMouseMove = GlobalMouseMove;
